import axios from 'axios'
import queryString from 'querystring'
import { getCookie } from '../ultils/cookie'

const token = getCookie('idToken')

export class HttpServices {
  public static async doGet(url: string, query: any) {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      }
      let result = await axios.request({
        headers,
        url: `${url}?${queryString.stringify(query)}`,
        method: 'GET',
      })
      return result.data
    } catch (e) {
      return Promise.reject(e)
    }
  }

  public static async doPost(url: string, data?: any) {
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    let result = await axios.request({
      headers,
      url,
      data,
      method: 'POST',
    })
    return result.data
  }

  public static async doPut(url: string, data?: any) {
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    let result = await axios.request({
      headers,
      url,
      data,
      method: 'PUT',
    })
    return result.data
  }

  public static async doDelete(url: string, data?: any) {
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    let result = await axios.request({
      headers,
      url,
      data,
      method: 'DELETE',
    })
    return result.data
  }
}
